import { render } from "./badges.vue?vue&type=template&id=1be3e04e"
import script from "./badges.vue?vue&type=script&lang=js"
export * from "./badges.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__